import {
  REQUEST_STATES_LIST,
  RECEIVE_STATES_LIST,
  ERROR_STATES_LIST,

  REQUEST_COUNTIES_BY_STATE,
  RECEIVE_COUNTIES_BY_STATE,
  ERROR_COUNTIES_BY_STATE,

  REQUEST_ALL_COUNTIES,
  RECEIVE_ALL_COUNTIES,
  ERROR_ALL_COUNTIES,

  REQUEST_ALL_SERVICE_REGIONS,
  RECEIVE_ALL_SERVICE_REGIONS,
  ERROR_ALL_SERVICE_REGIONS,

  REQUEST_COUNTY_BOUNDARIES_LIST,
  RECEIVE_COUNTY_BOUNDARIES_LIST,
  ERROR_COUNTY_BOUNDARIES_LIST,
  CLEAR_COUNTY_BOUNDARIES_LIST,

  REQUEST_ASSIGN_STATES_MANAGER,
  RECEIVE_ASSIGN_STATES_MANAGER,
  ERROR_ASSIGN_STATES_MANAGER,

  REQUEST_ASSIGN_COUNTIES_MANAGER,
  RECEIVE_ASSIGN_COUNTIES_MANAGER,
  ERROR_ASSIGN_COUNTIES_MANAGER,

} from 'typeConstants';
import { region as initialState } from '../initialState.tsx';

const region = (state = initialState, action) => {
  switch (action.type) {
      case REQUEST_STATES_LIST:
          return {
              ...state,
              isFetchingStates: true
          };
      case RECEIVE_STATES_LIST:
          return {
              ...state,
              states: action.payload,
              isFetchingStates: false
          };
      case ERROR_STATES_LIST:
          return {
              ...state,
              isFetchingStates: false
          };
      case REQUEST_COUNTIES_BY_STATE:
          return {
              ...state,
              isFetchingCountiesByState: true
          };
      case RECEIVE_COUNTIES_BY_STATE:
          return {
              ...state,
              countiesByState: action.payload,
              isFetchingCountiesByState: false
          };
      case ERROR_COUNTIES_BY_STATE:
          return {
              ...state,
              isFetchingCountiesByState: false
          };
      case REQUEST_ALL_COUNTIES:
          return {
              ...state,
              isFetchingAllCounties: true
          };
      case RECEIVE_ALL_COUNTIES:
          return{
            ...state,
            allCounties: action.payload,
            isFetchingAllCounties: false
        };
      case ERROR_ALL_COUNTIES:
          return{
            ...state,
            isFetchingAllCounties: false
        };
      case REQUEST_ALL_SERVICE_REGIONS:
        return {
            ...state,
            isFetchingServiceRegions: true,
        };
      case RECEIVE_ALL_SERVICE_REGIONS:
        return {
            ...state,
            isFetchingServiceRegions: false,
            serviceRegions: action.payload,
        };
      case ERROR_ALL_SERVICE_REGIONS:
        return {
            ...state,
            isFetchingServiceRegions: false,
        };
      case REQUEST_COUNTY_BOUNDARIES_LIST:
          return {
              ...state,
              isFetchingCountyBoundaries: true,
          };
      case RECEIVE_COUNTY_BOUNDARIES_LIST:
          return {
              ...state,
              isFetchingCountyBoundaries: false,
              countyBoundaries: action.payload.reduce((acc, cb) => {
                  acc[cb.properties.id] = { ...cb, ...JSON.parse(cb.boundaryJSON) };
                  return acc;
              }, {...state.countyBoundaries})
          };
      case ERROR_COUNTY_BOUNDARIES_LIST:
          return {
              ...state,
              isFetchingCountyBoundaries: false,
          };
      case CLEAR_COUNTY_BOUNDARIES_LIST:
          return {
              ...state,
              countyBoundaries: {}
          };
          case REQUEST_ASSIGN_STATES_MANAGER:
            return {
                ...state,
                isFetchingAssignedStates: true
            };
        case RECEIVE_ASSIGN_STATES_MANAGER:
            return {
                ...state,
                assignedStates: action.payload,
                isFetchingAssignedStates: false
            };
        case ERROR_ASSIGN_STATES_MANAGER:
            return {
                ...state,
                isFetchingAssignedStates: false
            };
        case REQUEST_ASSIGN_COUNTIES_MANAGER:
            return {
                ...state,
                isFetchingAssignedCounties: true
            };
        case RECEIVE_ASSIGN_COUNTIES_MANAGER:
            return {
                ...state,
                assignedCounties: action.payload,
                isFetchingAssignedCounties: false
            };
        case ERROR_ASSIGN_COUNTIES_MANAGER:
            return {
                ...state,
                isFetchingAssignedCounties: false
            };
      default:
          return state;
  }
};

export default region;